"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiWrapper = void 0;
exports.useUnified = useUnified;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var magicline_payment_service_1 = require("@src/modules/fitfms/membership-completion/services/magicline-payment.service");
var backend_services_1 = require("@src/services/backend-services");
var translation_1 = __importDefault(require("@src/services/translation"));
var object_service_1 = require("../services/object-service");
var settings_service_1 = require("../services/settings.service");
var agilea_api_1 = require("./agilea-api");
var athletics_api_1 = require("./athletics-api");
var magicline_api_1 = require("./magicline-api");
var none_api_1 = require("./none-api");
var themisoft_api_1 = require("./themisoft-api");
var fromFittec_1 = require("./unified/contract-templates/fromFittec");
var toFittec_1 = require("./unified/contract-templates/toFittec");
var fromFittec_2 = require("./unified/studios/fromFittec");
var fittec_ftp_api_1 = require("./unified/ftp/fittec-ftp.api");
var yond_api_1 = require("./yond-api");
function useUnified(settings, type) {
    var _a, _b;
    var technologyType = (_a = settings.get) === null || _a === void 0 ? void 0 : _a.technologyType;
    // option to force using backend to get contracts/studios (openAPI usually)
    if ((!technologyType || technologyType === 'magicline') && ((_b = settings.get) === null || _b === void 0 ? void 0 : _b.useUnifiedMagicline) === true) {
        return true;
    }
    var unifiedMap = {
        studios: ['yond', 'themisoft', 'agilea'],
        contracts: ['yond', 'themisoft', 'agilea'],
        leadCreation: ['yond', 'magicline', 'themisoft', 'agilea'],
        contractCreation: ['yond', 'magicline', 'themisoft', 'agilea'],
        trialBooking: ['yond', 'magicline'],
    };
    if (technologyType === undefined) {
        // fallback only if 'magicline' is allowed for this type
        return unifiedMap[type].includes('magicline');
    }
    return unifiedMap[type].includes(technologyType);
}
var ApiWrapper = /** @class */ (function () {
    function ApiWrapper() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.fittecFtpApi = object_service_1.ObjectService.getInstance(fittec_ftp_api_1.FittecFtpApi);
        this.ftpStudios = [];
    }
    ApiWrapper.prototype.getApi = function () {
        var api;
        //By default we use magicline api
        api = object_service_1.ObjectService.getInstance(magicline_api_1.MagiclineApi);
        if (this.config.get.technologyType === 'athletics') {
            api = object_service_1.ObjectService.getInstance(athletics_api_1.AthleticsApi);
            console.log('Using API: ', this.config.get.technologyType);
        }
        if (this.config.get.technologyType === 'agilea') {
            api = object_service_1.ObjectService.getInstance(agilea_api_1.AgileaApi);
            console.log('Using API: ', this.config.get.technologyType);
        }
        if (this.config.get.technologyType === 'themisoft') {
            api = object_service_1.ObjectService.getInstance(themisoft_api_1.ThemisoftApi);
            console.log('Using API: ', this.config.get.technologyType);
        }
        if (this.config.get.technologyType === 'none') {
            api = object_service_1.ObjectService.getInstance(none_api_1.NoneApi);
            console.log('Using API: ', this.config.get.technologyType);
        }
        return api;
    };
    ApiWrapper.prototype.createNewCustomer = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var hasMagiclinePaymentToken, usesMagiclinePaymentWidget, phonePrefix, mobile_phone, funnelConfigId, memberCreation, fmsUrl, endpoint;
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
            return __generator(this, function (_z) {
                console.log('new customer', body);
                hasMagiclinePaymentToken = !!(sessionStorage.getItem(magicline_payment_service_1.MAGICLINE_PAYMENT_TOKEN_KEY) ||
                    sessionStorage.getItem(magicline_payment_service_1.MAGICLINE_PAYMENT_INITIAL_TOKEN_KEY));
                usesMagiclinePaymentWidget = (_a = magicline_payment_service_1.MagiclinePaymentService.isEnabledForStudio(this.config)) !== null && _a !== void 0 ? _a : hasMagiclinePaymentToken;
                phonePrefix = localStorage.getItem('customer.phonePrefix');
                if (!phonePrefix) {
                    console.error('Missing phone prefix');
                    phonePrefix = '+49';
                }
                mobile_phone = body.customer.telephone_mobile.includes('+')
                    ? body.customer.telephone_mobile
                    : phonePrefix + body.customer.telephone_mobile;
                funnelConfigId = this.config.get.funnelConfigId;
                // if (!funnelConfigId) {
                //   _ShowErrorMessage(i18n.t('Missing funnel config, please ask an admin to fix it.'));
                //   return;
                // }
                if (useUnified(this.config, 'contractCreation')) {
                    memberCreation = __assign(__assign(__assign({ funnelConfigId: funnelConfigId, tenantKey: (_b = body.tenantKey) !== null && _b !== void 0 ? _b : '', fittecId: (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.fittecId, referralCode: body.customer.referralCode, voucherCode: body.voucherCode, guardian: body.guardian, dateOfBirth: body.customer.dateOfBirth, dateOfBirthNum: body.customer.dateOfBirth ? new Date(body.customer.dateOfBirth).getTime() : 0, email: body.customer.email, givenName: body.customer.firstname, familyName: body.customer.lastname, gender: (_d = body.customer.gender) !== null && _d !== void 0 ? _d : 'UNISEX', phone: mobile_phone, studioId: (_e = localStorage.getItem(input_mapping_const_1._AllMappings.studioId.uid)) !== null && _e !== void 0 ? _e : '', studioName: (_f = body.studioName) !== null && _f !== void 0 ? _f : '', member: __assign({ address: {
                                city: body.customer.city,
                                postalCode: body.customer.zipCode,
                                street: body.customer.street,
                                houseNumber: body.customer.houseNumber,
                                countryCode: body.customer.countryCode,
                            }, membershipId: (_g = body.contract.rateBundleTermId) === null || _g === void 0 ? void 0 : _g.toString(), originUrl: window.location.href, memberSince: new Date().getTime(), membershipName: body.membershipName, creationAOV: body.aov, checkIns: [] }, (((_h = body.customer.taxId) === null || _h === void 0 ? void 0 : _h.length) ? { taxId: body.customer.taxId } : {})), contractData: {
                            rateBundleTermId: (_j = body.contract.rateBundleTermId) === null || _j === void 0 ? void 0 : _j.toString(),
                            startDate: body.contract.startDate,
                            preuseDate: body.contract.preuseDate,
                            selectedRateBundleModules: body.contract.selectedRateBundleModules,
                            optionalRateBundleTermModules: body.contract.optionalRateBundleTermModules,
                            notes: body.contract.notes,
                            signaturePng: body.signaturePng,
                            signatureSvg: body.signatureSvg,
                        } }, (!usesMagiclinePaymentWidget &&
                        ((_k = body.customer) === null || _k === void 0 ? void 0 : _k.bankAccount) &&
                        ((_o = (_m = (_l = body.customer) === null || _l === void 0 ? void 0 : _l.bankAccount) === null || _m === void 0 ? void 0 : _m.accountHolder) === null || _o === void 0 ? void 0 : _o.length) &&
                        ((_r = (_q = (_p = body.customer) === null || _p === void 0 ? void 0 : _p.bankAccount) === null || _q === void 0 ? void 0 : _q.iban) === null || _r === void 0 ? void 0 : _r.length)
                        ? {
                            bankAccount: {
                                accountHolder: body.customer.bankAccount.accountHolder,
                                iban: body.customer.bankAccount.iban,
                            },
                        }
                        : {})), { paymentChoice: body.customer.paymentChoice || 'DIRECT_DEBIT', source: 'fms' }), (((_s = this.config.get) === null || _s === void 0 ? void 0 : _s.technologyType) === 'yond'
                        ? { provider: (0, yond_api_1.YondCustomerCreationData)(this.config) }
                        : ((_t = this.config.get) === null || _t === void 0 ? void 0 : _t.technologyType) === 'themisoft'
                            ? { provider: (0, themisoft_api_1.ThemisoftCustomerCreationData)() }
                            : ((_u = this.config.get) === null || _u === void 0 ? void 0 : _u.technologyType) === 'magicline' || ((_v = this.config.get) === null || _v === void 0 ? void 0 : _v.technologyType) === undefined
                                ? {
                                    provider: __assign({ name: 'magicline', studioId: (_w = localStorage.getItem(input_mapping_const_1._AllMappings.studioId.uid)) !== null && _w !== void 0 ? _w : '', paymentRequestToken: usesMagiclinePaymentWidget !== false
                                            ? (_x = sessionStorage.getItem(magicline_payment_service_1.MAGICLINE_PAYMENT_TOKEN_KEY)) !== null && _x !== void 0 ? _x : undefined
                                            : undefined, initialPaymentRequestToken: usesMagiclinePaymentWidget !== false
                                            ? (_y = sessionStorage.getItem(magicline_payment_service_1.MAGICLINE_PAYMENT_INITIAL_TOKEN_KEY)) !== null && _y !== void 0 ? _y : undefined
                                            : undefined }, (this.config.get.forceOpenAPI || usesMagiclinePaymentWidget ? { forceOpenAPI: true } : {})),
                                }
                                : {}));
                    fmsUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', this.config.get.environment);
                    endpoint = 'member/create';
                    if (body.guardian) {
                        endpoint = 'member/underage/create';
                    }
                    return [2 /*return*/, (0, backend_services_1.betterFetch)(fmsUrl + '/' + endpoint, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(memberCreation),
                        })
                            .then(function (createResponse) {
                            if (!createResponse.ok) {
                                return Promise.reject(createResponse.json());
                            }
                            return createResponse.json();
                        })
                            .then(function (created) {
                            var _a, _b, _c;
                            localStorage.setItem('customerName', (_a = created === null || created === void 0 ? void 0 : created.provider) === null || _a === void 0 ? void 0 : _a.customerName);
                            localStorage.setItem('customerNumber', (_b = created === null || created === void 0 ? void 0 : created.provider) === null || _b === void 0 ? void 0 : _b.customerNumber);
                            localStorage.setItem('quickRegistrationLink', (_c = created === null || created === void 0 ? void 0 : created.provider) === null || _c === void 0 ? void 0 : _c.quickRegistrationLink);
                            localStorage.setItem('id', created === null || created === void 0 ? void 0 : created.id);
                            return created;
                        })
                            .catch(function (createdErr) { return __awaiter(_this, void 0, void 0, function () {
                            var error;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, createdErr];
                                    case 1:
                                        error = _a.sent();
                                        throw error;
                                }
                            });
                        }); })];
                }
                else {
                    return [2 /*return*/, this.getApi().createNewCustomer(body)];
                }
                return [2 /*return*/];
            });
        });
    };
    ApiWrapper.prototype.previewNewCustomer = function (body) {
        console.log('preview new customer', body);
        return this.getApi().previewNewCustomer(body);
    };
    ApiWrapper.prototype.getStudios = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        if (((_a = this.config.get) === null || _a === void 0 ? void 0 : _a.useFtpDocuments) === true) {
            return this.fittecFtpApi.getStudios().then(function (studios) {
                _this.ftpStudios = studios;
                return studios;
            });
        }
        if (useUnified(this.config, 'studios')) {
            var fmsUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', this.config.get.environment);
            var provider = this.config.get.technologyType === 'magicline' || !((_b = this.config) === null || _b === void 0 ? void 0 : _b.get.technologyType)
                ? { name: 'magicline', forceOpenAPI: (_e = (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.get) === null || _d === void 0 ? void 0 : _d.forceOpenAPI) !== null && _e !== void 0 ? _e : false }
                : undefined;
            var endpoint = 'fms/studios/get';
            return (0, backend_services_1.betterFetch)(fmsUrl + '/' + endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    tenantKey: this.config.get.tenantKey,
                    fittecId: this.config.get.fittecId,
                    provider: provider,
                }),
            })
                .then(function (getResponse) {
                if (!getResponse.ok) {
                    return Promise.reject(getResponse.json());
                }
                return getResponse.json();
            })
                .then(function (studios) {
                return studios.map(function (s) { return (0, fromFittec_2.convertStudioFromFittec)(s); });
            })
                .catch(function (createdErr) { return __awaiter(_this, void 0, void 0, function () {
                var error;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, createdErr];
                        case 1:
                            error = _b.sent();
                            if (error.message) {
                                (0, generator_const_1._ShowErrorMessage)(translation_1.default.t((_a = error.message) !== null && _a !== void 0 ? _a : 'Failed getting studios'));
                            }
                            throw error;
                    }
                });
            }); });
        }
        return this.getApi().getStudios();
    };
    ApiWrapper.prototype.createLead = function (body) {
        return this.getApi().createLead(body);
    };
    ApiWrapper.prototype.validateVoucher = function (body) {
        console.log('new voucher', body);
        return this.getApi().validateVoucher(body);
    };
    ApiWrapper.prototype.getOfferings = function (studioId) {
        var _this = this;
        var _a, _b;
        console.log('get offerings', studioId);
        if (((_a = this.config.get) === null || _a === void 0 ? void 0 : _a.useFtpDocuments) === true) {
            var studio = (_b = this.ftpStudios.find(function (studio) { return studio.firestoreDocId === studioId; })) !== null && _b !== void 0 ? _b : this.ftpStudios.find(function (studio) { return String(studio.id) === studioId || studio.yondStudioOid === studioId; });
            return this.fittecFtpApi.getOfferings((studio === null || studio === void 0 ? void 0 : studio.firestoreDocId) || studioId);
        }
        if (useUnified(this.config, 'contracts')) {
            var fmsUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', this.config.get.environment);
            var getParams = (0, toFittec_1.convertGetContractTemplateToFittec)(studioId, this.config);
            var endpoint = '/fms/contract-templates/get';
            return (0, backend_services_1.betterFetch)(fmsUrl + endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(getParams),
            })
                .then(function (createResponse) {
                if (!createResponse.ok) {
                    return Promise.reject(createResponse.json());
                }
                return createResponse.json();
            })
                .then(function (data) {
                return data.map(function (d) { return (0, fromFittec_1.convertContractTemplateFromFittec)(d); });
            })
                .catch(function (createdErr) { return __awaiter(_this, void 0, void 0, function () {
                var error;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, createdErr];
                        case 1:
                            error = _b.sent();
                            if (error.message) {
                                (0, generator_const_1._ShowErrorMessage)(translation_1.default.t((_a = error.message) !== null && _a !== void 0 ? _a : 'Failed getting memberships'));
                            }
                            throw error;
                    }
                });
            }); });
        }
        return this.getApi().getOfferings(studioId);
    };
    return ApiWrapper;
}());
exports.ApiWrapper = ApiWrapper;
